import { NgModule } from '@angular/core';
import { DatePipe, DecimalPipe, SlicePipe, TitleCasePipe, UpperCasePipe, LowerCasePipe, CurrencyPipe, PercentPipe, AsyncPipe } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ScrollTrackerDirective } from './scroll-tracker.directive';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { NgSelectModule } from '@ng-select/ng-select';
import { FlatpickrModule } from 'angularx-flatpickr';
import { SimplebarAngularModule } from 'simplebar-angular';
import { BaseChartDirective } from 'ng2-charts';

// Ngb Modules
import {
  NgbNavModule,
  NgbAccordionModule,
  NgbDropdownModule,
  NgbPaginationModule,
  NgbAlertModule,
  NgbTooltipModule,
  NgbModalModule,
  NgbOffcanvasModule
} from '@ng-bootstrap/ng-bootstrap';

// Helpers
import { DirectivesModule } from './directives.module';
import { ApplicationPipesModule } from '../core/helpers/ApplicationPipes.module';


// Directive
import { ScrollspyDirective } from './scrollspy.directive';

// components
import { FilterControlComponent } from './filter-control/filter-control.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';


import { UserActivityLogs } from './user-activity-logs/user-activity-logs.component';
import { LanguageSelectComponent } from './language-select/language-select.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { NoDataFoundComponent } from './no-data-found/no-data-found.component';
import { LeanAccessPeriodComponent } from './lean-access-period/lean-access-period.component';
import { QRCodeComponent } from 'angularx-qrcode';
import { AIChatPoupUpComponent } from '../pages/deben-AI-assistant/ai-chat-poup-up/ai-chat-poup-up.component';
import { HasPermissionPipe } from './pipes/has-permission.pipe';
import { CanPipe } from './pipes/can.pipe';
import { SoftPurgeConfirmationModalComponent } from './soft-purge-confirmation-modal/soft-purge-confirmation-modal.component';
import { BankAccountActionConfirmationModalComponent } from './bank-account-action-confirmation-modal/bank-account-action-confirmation-modal.component';
import { DuplicateTransactionsModalComponent } from './duplicate-transactions-modal/duplicate-transactions-modal.component';
import { SkeletonLoaderComponent } from './loading-states/skeleton-loader/skeleton-loader.component';

// ngx-mask now uses provideNgxMask() in app.config or providers

@NgModule({
  declarations: [
    BreadcrumbsComponent,
    FilterControlComponent,
    UserActivityLogs,
    ScrollTrackerDirective,
    ScrollspyDirective,

    LanguageSelectComponent,

    AIChatPoupUpComponent,
    HasPermissionPipe,
    CanPipe,
    NoDataFoundComponent,
    LeanAccessPeriodComponent,
    SoftPurgeConfirmationModalComponent,
    BankAccountActionConfirmationModalComponent,
    DuplicateTransactionsModalComponent
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgbNavModule,
    NgbAccordionModule,
    NgbDropdownModule,
    NgbPaginationModule,
    NgbModalModule,
    NgbOffcanvasModule,
    NgbTooltipModule,
    TranslateModule,
    NgxSliderModule,
    NgSelectModule,
    FlatpickrModule,
    NgbAlertModule,
    SimplebarAngularModule,
    BaseChartDirective,
    NgbTooltipModule,
    NgApexchartsModule,
    RouterModule,
    QRCodeComponent,
    NgxMaskDirective,
    NgxMaskPipe,
    DatePipe,
    DecimalPipe,
    SlicePipe,
    TitleCasePipe,
    UpperCasePipe,
    LowerCasePipe,
    CurrencyPipe,
    PercentPipe,
    AsyncPipe,
    DirectivesModule,
    ApplicationPipesModule,
    SkeletonLoaderComponent
  ],
  exports: [
    BreadcrumbsComponent,
    FilterControlComponent,
    UserActivityLogs,
    ScrollTrackerDirective,
    ScrollspyDirective,

    LanguageSelectComponent,
    NoDataFoundComponent,
    LeanAccessPeriodComponent,
    AIChatPoupUpComponent,
    HasPermissionPipe,
    CanPipe,
    SoftPurgeConfirmationModalComponent,
    BankAccountActionConfirmationModalComponent,
    DuplicateTransactionsModalComponent,
    NgxMaskDirective,
    NgxMaskPipe,
    TranslateModule,
    DatePipe,
    DecimalPipe,
    SlicePipe,
    TitleCasePipe,
    UpperCasePipe,
    LowerCasePipe,
    CurrencyPipe,
    PercentPipe,
    AsyncPipe,
    // Forms
    FormsModule,
    ReactiveFormsModule,
    // Ngb
    NgbNavModule,
    NgbAccordionModule,
    NgbDropdownModule,
    NgbPaginationModule,
    NgbAlertModule,
    NgbTooltipModule,
    NgbModalModule,
    NgbOffcanvasModule,
    // Libs
    NgxSliderModule,
    NgSelectModule,
    FlatpickrModule,
    SimplebarAngularModule,
    BaseChartDirective,
    NgApexchartsModule,
    QRCodeComponent,
    // Helpers
    DirectivesModule,
    ApplicationPipesModule,
    SkeletonLoaderComponent
  ],
  providers: [DatePipe, DecimalPipe]
})
export class SharedModule { }
